import { ProtectedRoute } from "@app/protected-route";
import type { SectionType } from "@entities/model/model";
import { ModelSettings } from "@pages/model-settings/model-settings";
import {
	type FieldTypeFilter,
	isFieldTypeFilter,
	isModelSection,
} from "@pages/model-settings/types";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
	section: SectionType;
	fieldType: FieldTypeFilter;
}

export const Route = createFileRoute("/_layout/settings/models/$modelId/")({
	component: RouteComponent,
	validateSearch: (search: Record<string, unknown>): SearchParams => ({
		section: isModelSection(search.section) ? search.section : "fields",
		fieldType: isFieldTypeFilter(search.fieldType) ? search.fieldType : "all",
	}),
});

function RouteComponent() {
	return (
		<ProtectedRoute
			requiredPermissions={["root", "model_settings", "scoring_settings"]}
		>
			<ModelSettings />
		</ProtectedRoute>
	);
}
